export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AppDrawer.vue?vue&type=template&id=75c3694a&"


//////////////////
// WEBPACK FOOTER
// ./src/components/core/AppDrawer.vue?vue&type=template&id=75c3694a&
// module id = 164
// module chunks = 32